export const themeEmojis = {
  park: ["🌸","✨"],
  kitchen: ["🍪", "🥛", "🥐", "🍰", "🍩", "🍎", "🍌", "🍉", "🍓", "🍒"],
  coffee: ["☕","🍪"],
  village: ["🍂", "🍃", "🍁"],
  highrise: [ "✨", "🌟"]
};


//   coffee: ["☕", "🍫", "🍩", "🥐", "🍪"],
//   park: ["🌳", "🌸", "🍃", "🌼","🌷",],
 //  village: ["🏡", "🌾", "🌻", "🪁"],
//   kitchen: ["🍪", "🥛", "🥐", "🍰", "🍩", "🍎", "🍌", "🍉", "🍓", "🍒"],
